/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import { useState, createContext, useEffect, useCallback, useContext } from 'react';
import { setLineFun } from '../Config/OnLineCheker';
import { don } from '../Config/Coneccion';
import { setPermisos } from '../Config/Permisos';
export interface SeccionType {
    data: {
        User: any
        Permisos: Array<any>
        online: boolean
        cargando: boolean
        seccion: boolean
    }
    logout: () => void,
    user: () => void
}
export const SeccionContext = createContext<SeccionType>({
    data: {
        User: {}, Permisos: [], online: false, cargando: true, seccion: true
    },
    logout: () => { }, user: () => { }
})
export function SeccionProvider({ children }: { children: any }) {
    const [User, setUser] = useState({
        id_usuario: -1,
        usuario: '',
        nivel: 0,
        fecha: '',
        rol: '',
        permisos: []
    });
    const [Permisos, setPermiso] = useState<string[]>([]);
    const [online, setOnline] = useState(false);
    const [cargando, setCargando] = useState(true);
    const [seccion, setSeccion] = useState(true);
    setLineFun(setOnline);
    const user = useCallback(async () => {
        try {
            // //solicitar nuevos datos
            let token = localStorage.getItem('Authorization');
            let response = await fetch(don + '/api/Auth/me', { headers: { 'Authorization': 'Bearer ' + token } });
            let data: any = await response.json();
            setCargando(false);
            if (data !== null) {
                setSeccion(true);
                data.usuario = data.nombre;
                setUser(data);
                setPermiso(data.permisos);
            } else {
                setSeccion(false);
            }
        } catch (err) {
        }
    }, [])
    const logout = useCallback(async () => {
        try {
            let token = localStorage.getItem('Authorization');
            let response = await fetch(don + '/api/Auth/close', { headers: { 'Authorization': 'Bearer ' + token } });
            localStorage.removeItem('Authorization');
            await response.json();
            user();
        } catch (err) {
        }
    }, [])
    setPermisos(useCallback((per: string[]) => per.some(p => Permisos.some(a => a === p)), [Permisos]))
    useEffect(() => { user() }, []);
    return <SeccionContext.Provider value={{
        data: { User, Permisos, online, cargando, seccion },
        user, logout,
    }}>{children}</SeccionContext.Provider>
}
export const SeccionConsumer = SeccionContext.Consumer;

export function permisoSome(p: string[] = []) {
    const { data: { Permisos } } = useContext(SeccionContext) as SeccionType;
    return Permisos.some(d => p.some(p => d === p));

}
export function permisoAny(p: string[] = []) {
    const { data: { Permisos } } = useContext(SeccionContext) as SeccionType;
    return Permisos.every(d => p.some(p => d === p));

}